// 整体评价 
<template>
	<div v-if="allStudentTags.length>0">
		<div class="header-title" style="margin-bottom:20px">学生评价</div>
		<student-tag-cascader disabled :selectedTags="allStudentTags" border ref="allStudentTagRef" />
	</div>
</template>

<script>
	import StudentTagCascader from '@/views/record/record-tag-cascader.vue';
	import { studentTapApi } from '@/boot-api/record'
	import { mapState } from 'vuex'
	export default {
		components: { StudentTagCascader },
		props: {
			docId: {
				type: Number,
				required: true
			}
		},
		computed: {
			...mapState('record', {
				allStudentTags(state) {
					return state.studentTags.flatMap(v => v.tags)
				}
			})
		},
	
		mounted() {
		
			this.$store.dispatch('record/getStudentTags', this.docId)
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/record/student-tag/record-all-tags.vue